import { useAppSelector } from '@/hooks/useAppSelector';
import * as clientSlice from '@/data/client.slice';

/**
 * The most recently used reasons for trip, most recent first.
 *
 * This is the single seam between the grouped drop-down and the recency data.
 * The list is loaded into the client slice alongside the passenger client data
 * (`fetchPassengerClientDataAsync`), so the field — which renders once per trip
 * leg on a multi-trip reservation — reads it without fetching per row.
 *
 * Not yet intersected with what the member can book; `buildReasonForTripOptions`
 * does that.
 */
export function useRecentPurposeCodeUUIDs(): string[] {
  return useAppSelector(clientSlice.selectRecentPurposeCodeUUIDs);
}
